import { useQuery } from "@tanstack/react-query";
import { listIngestionJobsApiDocumentsUploadGet, type JobPhase, type IngestionJobSummary } from "@noa/api-core";
import { UploadQueryKey } from "../../query-keys";

export interface UseUploadJobsOptions {
  limit?: number;
  offset?: number;
  phase?: JobPhase;
}

export function useUploadJobs(options: UseUploadJobsOptions = {}) {
  const { limit = 20, offset = 0, phase } = options;

  const { data, isPending, refetch, isError, error } = useQuery({
    queryKey: [...UploadQueryKey.list(), limit, offset, phase ?? "all"],
    queryFn: async () => {
      const { data } = await listIngestionJobsApiDocumentsUploadGet({
        query: { limit, offset, phase },
        throwOnError: true,
      });
      return data;
    },
  });

  return {
    jobs: data?.jobs ?? ([] as IngestionJobSummary[]),
    total: data?.total ?? 0,
    isLoading: isPending,
    refetch,
    isError,
    error,
  };
}
